import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-analytics-charts/react-analytics-charts/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "how-to-get-an-oauth-client-id-from-google"
    }}>{`How To Get An OAuth Client ID From Google`}</h1>
    <p>{`Creating an OAuth Client ID for the Google Analytics API is easy and only takes a few minutes.`}</p>
    <p>{`Just follow the links for these three steps:`}</p>
    <h2 {...{
      "id": "1-enable-the-google-analytics-api"
    }}>{`1. `}<a parentName="h2" {...{
        "href": "https://console.developers.google.com/apis/library/analytics.googleapis.com"
      }}>{`Enable the Google Analytics API`}</a></h2>
    <p>{`Click the "Enable" button to enable the Google Analytics API. Move to the next step if it's already enabled.`}</p>
    <h2 {...{
      "id": "2-set-up-oauth-consent"
    }}>{`2. `}<a parentName="h2" {...{
        "href": "https://console.developers.google.com/apis/credentials/consent"
      }}>{`Set up OAuth consent`}</a></h2>
    <p>{`If you're just testing things out, this consent info isn't super important yet.`}</p>
    <ul>
      <li parentName="ul">{`At a minimum, include the following:`}
        <ul parentName="li">
          <li parentName="ul">{`Application name`}</li>
          <li parentName="ul">{`Support email`}</li>
          <li parentName="ul"><strong parentName="li">{`Add this scope: `}<inlineCode parentName="strong">{`View your Google Analytics data`}</inlineCode></strong></li>
          <li parentName="ul">{`Authorized domains`}</li>
          <li parentName="ul">{`Application Homepage link`}</li>
          <li parentName="ul">{`Application Privacy Policy link`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Then click Save`}</li>
    </ul>
    <p>{`You can now create a Client ID, but users will see a security warning until your OAuth consent info is verified by Google.`}</p>
    <p>{`According to Google, development/testing projects or projects which are not yet live to the public are ineligible for verification, so feel free to do that later.`}</p>
    <h2 {...{
      "id": "3-create-new-web-application-credentials"
    }}>{`3. `}<a parentName="h2" {...{
        "href": "https://console.developers.google.com/apis/credentials/oauthclient"
      }}>{`Create new "Web application" credentials`}</a></h2>
    <p>{`Give it a name and be sure to specify the domain origins where you'll be using it from (including `}<inlineCode parentName="p">{`localhost:port`}</inlineCode>{` if testing locally). You can always add/remove domain origins later.`}</p>
    <h3 {...{
      "id": "your-client-id-is-ready"
    }}>{`Your Client ID is ready!`}</h3>
    <p>{`You can find it at any time by visiting `}<a parentName="p" {...{
        "href": "https://console.developers.google.com/apis/credentials"
      }}>{`API credentials`}</a>{`. This is also where you'll go to add/remove domain origins from your credentials.`}</p>
    <br />
    <p><strong parentName="p">{`Your OAuth Client ID should look something like the following:`}</strong></p>
    <pre><code parentName="pre" {...{}}>{`1234567897441-uqe824vvuhc82t9ilovetacos69p5r79.apps.googleusercontent.com
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      